import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { head, get } from 'lodash';
import { verificationPropTypes } from '../../states/payments/propTypes';
import IFTPaymentDetails from '../PaymentDetails/ifts/IFTPaymentDetails';
import { CONST_AMOUNT_UPPERCASE } from '../../constants/Constants';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import viewPaymentContent, { contentPropTypes } from './ViewPayment.content';
import withContent from '../../containers/withContent';

const ViewIFTPayment = ({ paymentToView, content }) => {
	const { payments, created_timestamp } = paymentToView;
	const firstPayment = head(payments);
	const { subTitle } = content;
	const payment = {
		...firstPayment,
		created_timestamp,
		chargeAmount: firstPayment.charge_amount.find((chargeAmount) => chargeAmount.type === CONST_AMOUNT_UPPERCASE),
		exchangeRate: get(firstPayment, 'indicative_fx.rate'),
	};
	return (
		<div>
			<SectionHeading>{subTitle}</SectionHeading>
			<IFTPaymentDetails payment={payment} />
		</div>
	);
};

ViewIFTPayment.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	paymentToView: PropTypes.shape(verificationPropTypes),
};

const contentWrapper = withContent({ content: viewPaymentContent });
export default connect()(contentWrapper(ViewIFTPayment));
